import { render, staticRenderFns } from "./OrthoShoulderDifficultyReaching.vue?vue&type=template&id=160359d6&scoped=true"
import script from "./OrthoShoulderDifficultyReaching.vue?vue&type=script&lang=js"
export * from "./OrthoShoulderDifficultyReaching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160359d6",
  null
  
)

export default component.exports